var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import * as types from './types';
import * as statuses from '../../states';
var initialState = {
    id: 0,
    edit: false,
    name: '',
    closed: false,
    project_page: {
        introduction: '',
        id_marketing: null,
        id_solution: null,
        id_why_invest: null,
        id_growth: null,
        id_project: null,
        version: 2,
        why_invest: {
            header: '',
            description: ''
        },
        marketing: {
            header: '',
            description: ''
        },
        growth: {
            header: '',
            description: ''
        },
        solution: {
            header: '',
            description: ''
        },
        teams: [],
        logo: '',
        cover: ''
    },
    logo: null,
    cover: null,
    fetching_status: statuses.IDLE,
    edit_status: statuses.IDLE,
};
export default function projectReducer(state, action) {
    if (state === void 0) { state = initialState; }
    var type = action.type, payload = action.payload;
    switch (type) {
        case types.FETCH_PROJECT_REQUEST:
            return __assign(__assign({}, state), { fetching_status: statuses.LOADING });
        case types.FETCH_PROJECT_SUCCEEDED:
            return __assign(__assign({}, state), { id: (payload === null || payload === void 0 ? void 0 : payload.id) || state.id, name: (payload === null || payload === void 0 ? void 0 : payload.name) || state.name, logo: (payload === null || payload === void 0 ? void 0 : payload.logo) || state.logo, cover: (payload === null || payload === void 0 ? void 0 : payload.cover) || state.cover, closed: (payload === null || payload === void 0 ? void 0 : payload.closed) || state.closed, project_page: __assign(__assign({}, state.project_page), ((payload === null || payload === void 0 ? void 0 : payload.project_page) || {})), fetching_status: statuses.SUCCESS });
        case types.FETCH_PROJECT_FAILED:
            return __assign(__assign({}, state), { fetching_status: statuses.FAIL });
        default:
            return state;
    }
}
